<template>
  <HelloWorld />
</template>

<script>
import 'bootstrap/dist/css/bootstrap.min.css'
import HelloWorld from './components/HelloWorld.vue'

export default {
  name: 'App',
  components: {
    HelloWorld
  },
  methods:{
    changeLanguage (locale) {
      this.$i18n.locale = locale
      this.selectedLanguage = locale
      this.isDropdownOpened = false
    },
  }

}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;

}
</style>
